module.exports = "/lucky-balls/img/regular_game/header_elbet.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_elbet.png
// module id = 1145
// module chunks = 0